import "../assets/css/App.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        Contact us at:{" "}
        <a href="mailto:coaching@buildmybizbrand.com">
            coaching@buildmybizbrand.com
        </a>
      </p>
      <p>© {new Date().getFullYear()} MyBizBrand. All rights reserved.</p>
    </footer>
  );
}
